itsoftApp.createModule("showOnScroll", function () {
    const module = this;

    class ShowBlock {
        elems = document.querySelectorAll(".js-anim:not(._is-show)");
    
        showedElemsCount = 0;
    
        constructor() {
            if (this.elems.length > 0) {
                this.init();
            }
        }

        getOffset(el) {
            const rect = el.getBoundingClientRect();
            const scrollLeft = window.scrollX || document.documentElement.scrollLeft;
            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            return {
              top: rect.top + scrollTop,
              left: rect.left + scrollLeft,
            };
          }
          
    
        checkPosition() {
            if (this.elems.length === this.showedElemsCount) {
                ["scroll", "resize"].forEach((e) => {
                    window.removeEventListener(e, this.checkPosition);
                });
            } else {
                this.value = window.scrollY + document.documentElement.clientHeight;
                this.showElems();
            }
        }
    
        showElems() {
            this.elems.forEach((el) => {
            if (
                !el.classList.contains("_is-show") &&
                this.value > this.getOffset(el).top
            ) {
                el.classList.add("_is-show");
                this.showedElemsCount++;
            }
            });
        }
    
        addListeners() {
            ["scroll", "resize"].forEach((e) => {
                window.addEventListener(e, this.checkPosition);
            });
        }
    
        init() {
            this.checkPosition = this.checkPosition.bind(this);
            this.checkPosition();
            this.addListeners();
        }
    }

    new ShowBlock();

    module.callback = ShowBlock;
});